import { lazy, Suspense } from 'react'
import QRLayout from '../layouts/QRLanding'
import LoadingState from '../components/LoadingState'

// FIXME: Move page to "pages/qr/Scan.tsx".
const QRScan = lazy(() => import('../pages/dashboards/QRLanding/QRScanning'))

// FIXME: Change path to "/qr/scan" and move to "routes/qr.tsx".
export default [
  {
    path: '/scan',
    element: (
      <QRLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <QRScan />
        </Suspense>
      </QRLayout>
    )
  }
]
